// extracted by mini-css-extract-plugin
module.exports = {"author-image":"_2ZICw","wrapper":"_1fuk_","published-on":"_1xBPb","date":"_3UkOO","date-time":"_3psRs","author-info":"_1vXrL","share-icon":"_2RhLU","twitter":"bUxNR"};